import React, { useState } from 'react';
import '../styles/NavBar.css';

import { Menu, Notifications, Search, ArrowDropDown } from '@material-ui/icons';

import { Avatar, Badge, Box } from '@material-ui/core';

import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import HomeIcon from './HomeIcon';
import { Link } from 'react-router-dom';

import youtube from '../assets/youtube.png';
import facebook from '../assets/facebook.png';
import instagram from '../assets/instagram.png';
import twitter from '../assets/twitter.png';
import pin from '../assets/pin.png';

import home from '../assets/home.png';
import videos from '../assets/videos.png';
import audeos from '../assets/audeos.png';
import pictures from '../assets/pictures.png';
import articles from '../assets/articles.png';
import channels from '../assets/channels.png';
import liked from '../assets/liked.png';
import history from '../assets/history.png';
import saved_list from '../assets/saved_list.png';
import subscriptions from '../assets/subscriptions.png';

const NavBar = () => {
  const [left, setLeft] = useState(false);

  const toggleDrawer = (left, open) => (event) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setLeft(open);
  };

  return (
    <>
      <div className="navbar">
        <div className="navbar__leftIconDiv">
          <Button onClick={toggleDrawer('left', true)}>
            <Menu className="nabbar__menuButton" />
          </Button>
          <h2>Logo</h2>
        </div>

        <div className="navbar__inputDiv">
          <input type="text" placeholder=" Search videos..." />
          <Search className="navbar__search" />
        </div>

        <div className="navbar__social">
          <img className="navbar__socialimg " src={youtube} alt="Youtube" />
          <img
            className="navbar__socialimg "
            src={facebook}
            alt="Facebook"
          />{' '}
          <img className="navbar__socialimg " src={instagram} alt="Instagram" />{' '}
          <img className="navbar__socialimg " src={twitter} alt="Twitter" />{' '}
          <img className="navbar__socialimg " src={pin} alt="Pintrest" />{' '}
        </div>

        <div className="navbar__rightIconDiv">
          {/* <Switch className="navbar__switch" onChange={onToggleDark} /> */}
          <Box mr={3}>
            <Badge badgeContent={4} color="secondary">
              <Notifications />
            </Badge>
          </Box>
          <Avatar src="" className="nav__avatar" />
          <ArrowDropDown />
        </div>
        <SwipeableDrawer
          anchor={'left'}
          open={left}
          onClose={toggleDrawer('left', false)}
          onOpen={toggleDrawer('left', true)}
        >
          <div
            className="sidebar__row"
            role="presentation"
            onClick={toggleDrawer('left', false)}
            onKeyDown={toggleDrawer('left', false)}
          >
            <Link to="/" className="sidebar__links">
              <HomeIcon selected Icon={home} name="Home" />
            </Link>
            <Link to="videos" className="sidebar__links">
              <HomeIcon Icon={videos} name="Videos" />
            </Link>
            <HomeIcon Icon={audeos} name="Audios" even />
            <HomeIcon Icon={pictures} name="Pictures" />
            <HomeIcon Icon={articles} name="Articles" even />
            <HomeIcon Icon={channels} name="Channels" />
            <hr className="sidebar__hr" />
            <Avatar src="" className="nav__sidebaravatar" />

            <HomeIcon Icon={liked} name="Liked" even />
            <HomeIcon Icon={history} name="History" />
            <HomeIcon Icon={saved_list} name="Saved List" even />
            <HomeIcon Icon={subscriptions} name="Subscriptions" />
          </div>
        </SwipeableDrawer>
      </div>
    </>
  );
};

export default NavBar;
